import { Chip } from '@mui/material';
import type { PaymentRequestStatus } from '../../types/paymentRequest';

const COLORS: Record<
    PaymentRequestStatus,
    'default' | 'primary' | 'success' | 'warning' | 'error' | 'info'
> = {
    Draft: 'default',
    Submitted: 'info',
    APPrepared: 'info',
    CAReviewed: 'info',
    FMApproved: 'info',
    GMApproved: 'info',
    FinalApproved: 'success',
    Executed: 'success',
    Returned: 'warning',
    Rejected: 'error',
    Voided: 'error',
};

interface Props {
    status: PaymentRequestStatus;
}

export default function PaymentRequestStatusChip({ status }: Props) {
    const color = COLORS[status] ?? 'default';
    return <Chip size="small" label={status} color={color} />;
}
